import { ThunkAction } from 'redux-thunk'

import { fetchOrgAccount } from './orgAccount'

import { PersonFormData } from 'admin/components/pages/PersonForm'
import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { AdministratorType, OrgAccountType } from 'admin/types'
import createApiReducer, {requestDataFor, receiveDataFor, handleErrorFor} from 'redux/utils/createApiDuck'
import { APIState, AdminTypes, AlertLevels } from 'types'




const moduleName = `${config.appName  }/organizationAdmin`

export default createApiReducer(moduleName)

export function fetchOrganizationAdmin(orgAccountId: string, kimId: number): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.getOrgAccount(orgAccountId)
      .then((orgAccount: OrgAccountType) => {
        const existingAdmin = orgAccount.administrators.find((a) => a.kimId === kimId && a.administratorType === AdminTypes.ORG_ADMIN)
        if (existingAdmin) {
          dispatch(receiveDataFor(moduleName)(existingAdmin))
          return existingAdmin
        } 
          throw new Error('ORG_ADMIN_NOT_FOUND')
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function createOrgAdmin(orgAccountId: string, requestData: PersonFormData): ThunkAction<Promise<any>, State, reduxDependenciesType>  {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.createAdministrator(orgAccountId, requestData, AdminTypes.ORG_ADMIN)
      .then((kimId: number) => {
        dispatch(fetchOrganizationAdmin(orgAccountId, kimId))
        return kimId
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function updateOrgAdmin(orgAccountId: string, kimId: number, requestData: PersonFormData): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.updatePersonInfo(orgAccountId, kimId, requestData)
      .then(() => {
        dispatch(fetchOrganizationAdmin(orgAccountId, kimId))
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}
export function getAdministratorsExcel(orgKimId: number): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (_dispatch, _getState, { api }) => {
    return api.getAdministratorsExcel(orgKimId)
  }
}

export function inactivateAdministrator(orgNumber: string, kimId: number): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }: reduxDependenciesType) => {
    const { login } = getState()

    // Check for deleting self
    if (login.data.kimId === kimId) {
      const error = {
        level: AlertLevels.INFO,
        message: 'CANNOT_DELETE_OWN_ADMIN_ACCOUNT',
      }
      dispatch(handleErrorFor(moduleName)(error))
      return Promise.reject('CANNOT_DELETE_OWN_ADMIN_ACCOUNT')
    }

    dispatch(requestDataFor(moduleName)())

    return api.inactivateOrganizationAdministrator(orgNumber, kimId)
      .then(({inactivated}) => {
        if (inactivated) {
          dispatch(receiveDataFor(moduleName)(null))
          return inactivated
        } 
          const error = {
            level: AlertLevels.ERROR,
            message: 'CANNOT_DELETE_ADMIN_ACCOUNT',
          }
          dispatch(handleErrorFor(moduleName)(error))
          return Promise.reject(error)
        
      })
      .catch((error) => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function updateOrganization(
  orgKimId: number, 
  foodCompany: boolean, 
  orgAccountId: string
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.updateOrganization(orgKimId, foodCompany)
      .then(() => {
        dispatch(fetchOrgAccount(orgAccountId))
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}


export interface OrganizationAdminState extends APIState {
  data: AdministratorType
}
